module.exports = __webpack_public_path__ + "static/media/DSC_0068.6e64a336.jpg";